import { OnlineBookingContainer } from '../../containers/advancedFilters/OnlineBookingContainer';
import { IFilter } from '../../types/advancedFilters';

export const onlineBooking: IFilter = {
  component: OnlineBookingContainer,
  availability: ({ config }) => Boolean(config.get<boolean>('dailyrent.onlineBookingFilterDesktop.Enabled')),
};
